// this is used to turn spoken date answers into standardized date strings
// they need to be of the form 
// yyyy-mm-dd 
// or  
// yyyy-mm-dd HH:MM:SS
// to be accepted as valid date answers

import { parse } from 'chrono-node';

export default function tryToInterpretDate(text, include_time = false) {
    console.log(`tryToInterpretDate called with input: "${text}"`);
    if (!text) return '';

    // Use chrono-node to parse the date
    const results = parse(text);
    if (results && results.length > 0 && results[0].start) {
        const date = results[0].start.date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        let standardizedDate = `${year}-${month}-${day}`;
        if (include_time) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            standardizedDate += ` ${hours}:${minutes}:${seconds}`;
        }
        console.log(`Interpreted date: "${standardizedDate}" from input: "${text}"`);
        return standardizedDate;
    } else {
        console.log(`Could not interpret a date from input: "${text}"`);
        return '';
    }
}
